import { Box, MenuItem, Select, TextField } from '@mui/material';
import React, { useState } from 'react';
import Label from '../UI/Label/Label';
import SearchableSelect from '../SearchableSelect';
import { useAuthStore } from '../../store/storeAuth';
import {
  NotificationType,
  useNotificationStore,
} from '../../store/storeNotifications';

interface PushGoogleSlidesDataProps {
  formData: any;
  onChange: (e: any) => void;
  onChangeSelect: (e: any) => void;
  id: string;
  data: any;
  type: string;
}

export enum SlideOptions {
  APPEND = 'Append to end',
}

interface IOptions {
  value: string;
  label: string;
}

const PushGoogleSlidesData: React.FC<PushGoogleSlidesDataProps> = ({
  formData,
  onChange,
  onChangeSelect,
  id,
  data,
  type,
}) => {
  const setNotification = useNotificationStore(state => state.setNotification);
  const { user } = useAuthStore(state => state);

  const [selectedOption, setSelectedOption] = useState<SlideOptions>(
    SlideOptions.APPEND,
  );

  const specifiedSlidePageChangeHandler = (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const { value } = e.target;

    if (isNaN(+value) || +value < 0) {
      return setNotification({
        type: NotificationType.Error,
        message: 'Page must be a valid positive number!',
      });
    }
    onChange(e);
  };

  return (
    <Box width={'370px'}>
      <Box
        sx={{
          margin: '10px 0',
        }}
      >
        <Label
          labelStyle={{ marginTop: '10px' }}
          labelName="Settings"
          isAdvanced
        />

        <TextField
          name="presentationId"
          label="Presentation ID"
          placeholder="Enter Presentation ID"
          value={formData.presentationId}
          onChange={onChange}
          InputProps={{
            style: {
              color: user?.theme === 'dark' ? '#D0D5DD' : '#101828',
            },
          }}
          sx={{
            color: user?.theme === 'dark' ? '#D0D5DD' : '#101828',
            bgcolor: user?.theme === 'dark' ? '#1D2939' : '#F9FAFB',
            border: `2px solid ${
              user?.theme === 'dark' ? '#475467' : '#EAECF0'
            }`,
          }}
        />

        <Box sx={{ margin: '15px 0' }}></Box>

        <Select
          value={selectedOption}
          label="Select an option"
          onChange={e => {
            onChangeSelect({
              target: { name: 'selectedSlideOption', value: e.target.value },
            });

            setSelectedOption(e.target.value as SlideOptions);
          }}
          className="nodrag"
        >
          {Object.values(SlideOptions).map(pushOption => (
            <MenuItem key={pushOption} value={pushOption}>
              {pushOption}
            </MenuItem>
          ))}
        </Select>
      </Box>

      {/* {selectedOption === SlideOptions.REPLACE && (
        <Box sx={{ margin: '4px 0' }}>
          <Label labelName="Page Number" isAdvanced />

          <TextField
            type="number"
            placeholder="Enter Slide Page"
            name="specifiedSlidePage"
            value={formData.specifiedSlidePage}
            onChange={specifiedSlidePageChangeHandler}
          />
        </Box>
      )} */}
    </Box>
  );
};

export { PushGoogleSlidesData };
